import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 라우트 변경 시 스크롤을 맨 위로 리셋한다.
 *
 * React Router는 페이지 이동 시 스크롤 위치를 자동으로 리셋하지 않아,
 * 이전 페이지에서 스크롤된 상태 그대로 새 페이지가 열리면
 * "상단이 잘린 채" 보이는 문제가 발생한다. (예: 홈 → 운동 기록)
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
